<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
const axios = require("axios");

export default {
  methods: {
    setProfile: async function() {
      try {
        const response = await axios.get(
          "https://kevin-waves-hello.firebaseio.com/.json"
        );
        this.$store.commit("setProfile", response.data);
      } catch (error) {
        console.error(error);
      }
    }
  },
  created: function() {
    this.setProfile();
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap');

body {
  margin: 0;
}

#app {
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Droid Sans, Helvetica Neue, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #24313f;
  font-size: 13px;

  a {
    color: unset;
    text-decoration: none;
  }
}
</style>
